//client/src/context/divesiteContext.js

import { createContext } from "react";
import { useReducer } from "react";

export const DivesitesContext = createContext();

export const divesitesReducer = (state, action) => {
    switch (action.type) {
        case 'SET_DIVESITES':
            return {
                divesites: action.payload
            };
        case 'CREATE_DIVESITE':
            return {
                divesites: [action.payload, ...state.divesites]
            };
        case 'UPDATE_DIVESITE':
            const updatedDivesite = action.payload;
            const updatedDivesites = state.divesites.map((divesite) => {
                if (divesite._id === updatedDivesite._id) {
                    return updatedDivesite;
                }
                return divesite;
            });
            return {
                divesites: updatedDivesites
            };
        default:
            return state;
    }

};

export const DivesitesContextProvider = ({ children }) => {
  const [state,dispatch] = useReducer(divesitesReducer, {
    divesites: []
  });

    

    return (
        <DivesitesContext.Provider value={{...state, dispatch}}>
            { children }
        </DivesitesContext.Provider>
    );
};